"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestedReportStatus_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var RequestedReportStatus_Factory = /** @class */ (function () {
    function RequestedReportStatus_Factory() {
    }
    RequestedReportStatus_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
        };
        return result;
    };
    RequestedReportStatus_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
        };
        return result;
    };
    return RequestedReportStatus_Factory;
}());
exports.RequestedReportStatus_Factory = RequestedReportStatus_Factory;
